import { render, staticRenderFns } from "./RatingCard.vue?vue&type=template&id=63c79aab&"
import script from "./RatingCard.vue?vue&type=script&lang=js&"
export * from "./RatingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports